"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActivityConfig = void 0;
/**
 * 将 kebab-case 字符串转换为 camelCase（运行时）
 *
 * @example
 * ```typescript
 * const camel = kebabToCamel('hello-world-events'); // 'helloWorldEvents'
 * ```
 */
function kebabToCamel(str) {
    return str.replace(/-([a-z])/g, (_, letter) => letter.toUpperCase());
}
/**
 * 活动配置类
 */
class ActivityConfig {
    /** Kafka 消费者配置列表（实现 IActivityConfig 接口） */
    get kafkaConsumers() {
        return this._kafkaConsumers;
    }
    /** Kafka 生产者 Topic 列表（实现 IActivityConfig 接口） */
    get kafkaProducers() {
        return this._kafkaProducers;
    }
    get consumers() {
        return this._buildNameMap();
    }
    get producers() {
        return this._buildTopicMap();
    }
    getFullGroupIds(businessLocation) {
        const location = businessLocation.toLowerCase();
        const activityName = this.apiPrefix.replace(/-/g, '_');
        const groupIds = {};
        this._kafkaConsumers.forEach((consumer) => {
            const groupIdKey = consumer.groupId || consumer.name;
            const camelKey = kebabToCamel(consumer.name);
            groupIds[camelKey] =
                `dg_rd_comops_render_server_${location}_${activityName}_${groupIdKey}`;
        });
        return groupIds;
    }
    constructor(config) {
        this.apiPrefix = config.apiPrefix;
        this.name = config.name;
        this.description = config.description;
        this.businessLocations = config.businessLocations;
        this._kafkaConsumers = config.kafkaConsumers || [];
        this._kafkaProducers = config.kafkaProducers || [];
    }
    _buildNameMap() {
        const map = {};
        this._kafkaConsumers.forEach((consumer) => {
            const camelKey = kebabToCamel(consumer.name);
            map[camelKey] = consumer;
        });
        return map;
    }
    _buildTopicMap() {
        const map = {};
        this._kafkaProducers.forEach((topic) => {
            const camelKey = kebabToCamel(topic);
            map[camelKey] = topic;
        });
        return map;
    }
    getConsumerByName(name) {
        return this._kafkaConsumers.find((consumer) => consumer.name === name);
    }
    getAllTopics() {
        const topics = new Set();
        this._kafkaConsumers.forEach((consumer) => {
            topics.add(consumer.topic);
        });
        return Array.from(topics);
    }
    toConfig() {
        return {
            apiPrefix: this.apiPrefix,
            name: this.name,
            description: this.description,
            businessLocations: this.businessLocations,
            kafkaConsumers: this._kafkaConsumers,
            kafkaProducers: this._kafkaProducers,
        };
    }
}
exports.ActivityConfig = ActivityConfig;
